import { Component, Host, h, Prop, State, Watch } from '@stencil/core';
import '../header-component/header-component'
import '../loader-component/loader-component'


/**
 


#### Sample screen shot
![image info](https://infonet.nyp.org/webc/PublishingImages/ticker-component.PNG)

#### Content Type
nypwebc_ct_about

 */
@Component({
  tag: 'ticker-component',
  styleUrl: 'ticker-component.css',
  scoped: true
})

export class TickerComponent {

  /**
   *Required - Unique ID.
   */
  @Prop() componentid: string = "comp-id";

  /**
  *Required - List Name.
  */
  @Prop() listname: string = "ListName";

  /**
  *Required - Relative to the root site. no trailing slash. for ex: /hr/pm
  */
  @Prop() webpath: string = "/";




  /**
*Optional - is it SP Online site
*/
  @Prop() online: boolean = false;

  /**
  *Required - site url if its sp online site
  */
  @Prop() siteurl: string = "";



  @State() isLoading: boolean = true
  @State() items: []

  componentDidLoad() {

    // const siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl;

    // let siteUrl: string = "";

    // if (this.online) {
    //   siteUrl = this.siteurl + this.webpath
    // }
    // else {
    //   siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl + this.webpath;
    // }

    let siteUrl: string = "";
    if ((window as any)._spPageContextInfo != null) {
      siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl + this.webpath;
    }
    else {
      let domain = new URL(window.location.href)
      siteUrl = domain.origin + this.webpath
    }
    const filter = "nypwebc_Active eq 1";

    return fetch(siteUrl + "/_api/web/lists/getbytitle('" + this.listname + "')/items?$select=ID,Title,nypwebc_Body&$filter=" + filter + "&$top=1", { headers: { "Accept": "application/json; odata=verbose" } })
      .then(response => response.json())
      .then(data => {
        this.items = data.d.results;
        this.isLoading = false;
      });
  }

  getContents = () => {

    const contentsArray = []
    this.items.forEach((item: any) => {
      let altImage = item.Title + " image"

      let bodystring: string = ""
      let domNode: any;
      let bodyexist: boolean = false

      if (item.nypwebc_Body != null) {
        bodystring = item.nypwebc_Body
        // if (this.embededvideo) {
        //   bodystring = item.nypwebc_Body.replaceAll('&#160;', '')
        // }
        // else {
        //   bodystring = item.nypwebc_Body
        // }

        bodyexist = true;
        let parser = new DOMParser();
        domNode = parser.parseFromString(bodystring, "text/html");
        const img = domNode.querySelectorAll("img");
        // const tables = domNode.querySelectorAll("table");
        // const videos = domNode.querySelectorAll("video");

        for (let i = 0; i < img.length; i++) {
          img[i].classList.add("sc-ticker-component", "img-fluid", "rounded");
        }

        // if (this.embededvideo) {
        //   for (let i = 0; i < videos.length; i++) {
        //     videos[i].setAttribute("controls", "controls")
        //   }
        // }
      }

      contentsArray.push(

        <div class="marquee-nyp raw-html-style-ticker">
          <p  innerHTML={domNode.body.innerHTML}></p>
        </div>
                

      )


    })
    //return   <ul class="ticker-right"> {contentsArray} </ul>
    return contentsArray


  }

  render() {

    return (
      this.isLoading ?
        <loader-component /> :
        <div class="row gx-0"  >
          {this.getContents()}
        </div>

    )



  }

}

